export const EI_RESULT_SECTIONS = [
	"level",
	"spectrum",
	"superpowers",
	"development",
	"comparison",
] as const

export type EiResultSection = (typeof EI_RESULT_SECTIONS)[number]

export function parseEiResultSection(value: unknown): EiResultSection {
	const section = EI_RESULT_SECTIONS.find((item) => item === value)
	return section ?? "level"
}
